module.exports = __webpack_public_path__ + "img/leftbicep-endo-mesomorph-male.95705a9d.svg";